module.exports = __webpack_public_path__ + "static/media/arrow.e08ead60.svg";